<div class="overflow-hidden carousel-wrapper">
  <div class="max-mobile-view m-a">
    <div class="px-4 py-2">
      <cui-carousel
        [itemsLength]="epc.energyPerformanceCertificateRecommendations != null ? 2 : 1"
        [hideIndicators]="true">
        @if (epc.energyPerformanceCertificateRecommendations != null) {
          <div class="mx-2 fill-light">
            <cp-ticket-container-dynamic
              [topHeightPx]="47"
              [bottomHeightPx]="90"
              [topTemplate]="recommendationsTopTemplate"
              [bottomTemplate]="recommendationsBottomTemplate" />
          </div>
        }

        <div class="mx-2 fill-light">
          <cp-ticket-container-dynamic
            [topHeightPx]="47"
            [bottomHeightPx]="90"
            [topTemplate]="savingsTopTemplate"
            [bottomTemplate]="savingsBottomTemplate" />
        </div>
      </cui-carousel>
    </div>
  </div>
</div>

<ng-template #recommendationsTopTemplate>
  <div class="flex h-100 w-100 align-items-center px-3 gap-2 no-wrap">
    <shared-icon icon="epc-improvements" size="large" class="fill-dark-gray-turquoise" />
    <div class="text-18 bold-800 h-fit">Energy Improvements</div>
  </div>
</ng-template>
<ng-template #recommendationsBottomTemplate>
  <div class="layout-fr-auto h-100 w-100 align-items-center p-3 text-start">
    @for (
      recommendation of epc.energyPerformanceCertificateRecommendations?.slice(0, 3);
      track recommendation
    ) {
      <div class="no-wrap text-ellipsis overflow-hidden text-10 bold-700 uppercase mr-2">
        {{ recommendation.title }}
      </div>
      <div class="no-wrap bold-700 justify-self-end">
        @if (recommendation.indicativeCostMinimum != null) {
          {{ recommendation.indicativeCostMinimum | currency: "GBP" : "symbol" : "1.0-0" }}+
        }
      </div>
    } @empty {
      No suggested improvements found.
    }
  </div>
</ng-template>

<ng-template #savingsTopTemplate>
  <div class="flex h-100 w-100 align-items-center px-3 gap-2 no-wrap">
    <shared-icon icon="pig-coin" size="large" class="fill-dark-gray-turquoise" />
    <div class="text-18 bold-800 h-fit">Potential Savings</div>
  </div>
</ng-template>
<ng-template #savingsBottomTemplate>
  <div class="layout-fr-auto h-100 w-100 align-items-center p-3 text-start">
    <div class="no-wrap text-ellipsis overflow-hidden text-10 bold-700 uppercase mr-2">
      HEATING SAVINGS FROM
    </div>
    <div class="no-wrap bold-700 justify-self-end">
      {{ (epc.heatingPotentialSavingYearly | currency: "GBP" : "symbol" : "1.0-0") ?? "--" }} p.a.
    </div>

    <div class="no-wrap text-ellipsis overflow-hidden text-10 bold-700 uppercase mr-2">
      HOT WATER SAVINGS FROM
    </div>
    <div class="no-wrap bold-700 justify-self-end">
      {{ (epc.hotWaterPotentialSavingYearly | currency: "GBP" : "symbol" : "1.0-0") ?? "--" }} p.a.
    </div>

    <div class="no-wrap text-ellipsis overflow-hidden text-10 bold-700 uppercase mr-2">
      LIGHTING SAVINGS FROM
    </div>
    <div class="no-wrap bold-700 justify-self-end">
      {{ (epc.lightingPotentialSavingYearly | currency: "GBP" : "symbol" : "1.0-0") ?? "--" }} p.a.
    </div>
  </div>
</ng-template>
